// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  /* Boost-Start-#200780 */
  Utils.isBadSearchTerm = (term) => {
	if (typeof term == 'string') {
		var domEvents = [
			"onabort",
			"popstate",
			"afterprint",
			"beforeprint",
			"beforeunload",
			"blur",
			"canplay",
			"canplaythrough",
			"change",
			"click",
			"contextmenu",
			"copy",
			"cut",
			"dblclick",
			"drag",
			"dragend",
			"dragenter",
			"dragleave",
			"dragover",
			"dragstart",
			"drop",
			"durationchange",
			"ended",
			"error",
			"focus",
			"focusin",
			"focusout",
			"fullscreenchange",
			"fullscreenerror",
			"hashchange",
			"input",
			"invalid",
			"keydown",
			"keypress",
			"keyup",
			"load",
			"loadeddata",
			"loadedmetadata",
			"loadstart",
			"mousedown",
			"mouseenter",
			"mouseleave",
			"mousemove",
			"mouseover",
			"mouseout",
			"mouseout",
			"mouseup",
			"offline",
			"online",
			"pagehide",
			"pageshow",
			"paste",
			"pause",
			"play",
			"playing",
			"progress",
			"ratechange",
			"resize",
			"reset",
			"scroll",
			"search",
			"seeked",
			"seeking",
			"select",
			"show",
			"stalled",
			"submit",
			"suspend",
			"timeupdate",
			"toggle",
			"touchcancel",
			"touchend",
			"touchmove",
			"touchstart",
			"unload",
			"volumechange",
			"waiting",
			"wheel",
		];
		var potentialEventRegex = new RegExp(domEvents.join("=|on"));
		var countOpenTag = (term.match(/</g) || []).length;
		var countCloseTag = (term.match(/>/g) || []).length;
		var isAlert = (term.match(/alert\(/g) || []).length;
		var isConsoleLog = (term.match(/console\.log\(/g) || []).length;
		var isExecCommand = (term.match(/execCommand/g) || []).length;
		var isCookie = (term.match(/document\.cookie/g) || []).length;
		var isJavascript = (term.match(/j.*a.*v.*a.*s.*c.*r.*i.*p.*t/g) || []).length;
		var isPotentialEvent = potentialEventRegex.test(term);
		if ((countOpenTag > 0 && countCloseTag > 0) ||
			isAlert || isConsoleLog || isExecCommand || isCookie || isJavascript || isPotentialEvent) {
			return true;
		}
	}
	return false;
}
  /* Boost-End-#200780 */

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }
   /* Boost-218667 */
  InstantSearchResultItemProduct.prototype.compileTemplate = function(){
    if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

            var urlHTML = '';
            if (Utils.isCartPage()) {
              urlHTML = this.url.replace('/cart','/collections/all');
            } else if (window.location.pathname.indexOf('/account') > -1) {
              urlHTML = this.url.replace('/account','/collections/all');
            } else {
              urlHTML = this.url;
            }
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, urlHTML)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
  }
   /* Boost-218667 */
})();